import { CssBaseline, ThemeProvider } from '@mui/material'
import { theme } from '@/theme'
import { Layout } from '@/components/layout/Layout'

/**
 * Root element for every route. HelmetProvider is supplied by vite-react-ssg
 * (both client and SSG server), so we must NOT add our own — a second provider
 * would shadow the context it extracts head tags from.
 */
export function RootLayout() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Layout />
    </ThemeProvider>
  )
}
